import { useMemo } from "react";
import { useInsights } from "@unu/ui-hooks";
import { createInsightsAdapter } from "./createInsightsAdapter";
import type { InsightsAdapter } from "./types";

export function useInsightsAdapter(): InsightsAdapter {
  const { tag } = useInsights();

  return useMemo(() => createInsightsAdapter(tag), [tag]);
}
